import Chat from 'react-freshchat';

const FreshChat = ({ token, setWidget, searchParams }) =>
  token ? (
    <Chat
      token={token}
      host="https://wchat.eu.freshchat.com"
      config={{
        headerProperty: {
          direction: 'ltr',
          hideChatButton: true,
        },
        fullscreen: window.innerWidth < 450,
      }}
      onInit={widget => {
        setWidget(widget);
        widget.user.setProperties(searchParams);
      }}
    />
  ) : null;

export default FreshChat;
